;(function () {
  function initJourneyMaterials(root) {
    var sections = (root || document).querySelectorAll('.journey-materials');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var navItems = section.querySelectorAll('.journey-materials__nav-item');
      var navLine = section.querySelector('.journey-materials__nav-line');
      var states = section.querySelectorAll('.journey-materials__state');
      var overlays = section.querySelectorAll('.journey-materials__overlay-wrap');
      var contents = section.querySelectorAll('.journey-materials__content');

      if (!navItems.length) return;

      function activate(index) {
        section.dataset.activeIndex = index;

        navItems.forEach(function (btn, i) {
          var isActive = i === index;
          btn.classList.toggle('journey-materials__nav-item--active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        states.forEach(function (state, i) {
          state.classList.toggle('journey-materials__state--active', i === index);
        });

        overlays.forEach(function (overlay, i) {
          overlay.classList.toggle('journey-materials__overlay-wrap--active', i === index);
        });

        contents.forEach(function (content, i) {
          content.classList.toggle('journey-materials__content--active', i === index);
        });

        positionLine(index);
      }

      function positionLine(index) {
        if (!navLine) return;
        var btn = navItems[index];
        if (!btn) return;
        // Line starts at active button's left edge, extends to right edge via CSS
        navLine.style.left = btn.offsetLeft + 'px';
      }

      // Desktop: mouseenter switches state
      navItems.forEach(function (btn, i) {
        btn.addEventListener('mouseenter', function () {
          activate(i);
        });
        // Mobile: click/tap switches state
        btn.addEventListener('click', function () {
          activate(i);
        });
      });

      // Touch swipe to switch states on mobile
      var touchStartX = 0;
      var touchEndX = 0;
      var swipeThreshold = 50;

      section.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      section.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) < swipeThreshold) return;

        var currentIdx = parseInt(section.dataset.activeIndex, 10) || 0;
        var maxIdx = navItems.length - 1;

        if (diff > 0 && currentIdx < maxIdx) {
          // Swipe left → next
          activate(currentIdx + 1);
        } else if (diff < 0 && currentIdx > 0) {
          // Swipe right → previous
          activate(currentIdx - 1);
        }
      }, { passive: true });

      // Initial state
      activate(0);

      // Reposition line on resize (debounced)
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var activeIdx = parseInt(section.dataset.activeIndex, 10) || 0;
          positionLine(activeIdx);
        }, 100);
      });

      // Reposition after fonts load
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          var activeIdx = parseInt(section.dataset.activeIndex, 10) || 0;
          positionLine(activeIdx);
        });
      }
    });
  }

  // Init on page load
  initJourneyMaterials();

  // Re-init in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initJourneyMaterials(event.target || document);
  });
})();
